import FingerprintJS from '@fingerprintjs/fingerprintjs';

const FingerPrintKey = 'browserFingerPrint';

let globalFingerPrint = localStorage.getItem(FingerPrintKey);

export default async function getBrowserFingerPrint() {
  if (globalFingerPrint) return globalFingerPrint;
  const fpPromise = FingerprintJS.load(); // 獲取瀏覽器唯一id
  const fp = await fpPromise;
  const result = await fp.get();
  localStorage.setItem(FingerPrintKey, result.visitorId);
  globalFingerPrint = result.visitorId;
  return result.visitorId;
}
